// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectPlace_container__2fBC7","input":"SelectPlace_input__J3Dj7","option":"SelectPlace_option__2obgy"};